<template>
  <div>退货详情</div>
</template>

<script>
export default {
  name: "returnDetail"
}
</script>

<style scoped>

</style>